const textFormatting = (value) => {
    return typeof value === "string" ? (value.toLowerCase()).charAt(0).toUpperCase() + value.slice(1) : value
}

export default textFormatting;